import './editorFonts.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { DocumentWorkspaceProvider } from './contexts/DocumentWorkspace';
import { AuthProvider } from './hooks/useAuth';
import { ThemeProvider } from './contexts/ThemeContext';
import './lib/i18n';
import './styles/globals.css';
// Must load AFTER globals.css: dark.css remaps the hardcoded Tailwind color
// utilities used across the app under `html.dark`.
import './styles/dark.css';
import './styles/desktop-shell.css';
import './styles/pdfAnnotationLayer.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <DocumentWorkspaceProvider><App /></DocumentWorkspaceProvider>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);
